// Współdzielona etykieta KaTeX wewnątrz SVG (przez foreignObject).
// Ujednolica podpisy w diagramach zadań E8: litery wierzchołków i wymiary
// renderowane tak samo jak w treści zadań (react-katex), zamiast surowego <text>.
//
// (x, y) to środek etykiety. Domyślnie wyśrodkowana.

import React from "react";
import { InlineMath } from "react-katex";

export default function SvgMathLabel({
  x,
  y,
  math,
  color = "currentColor",
  fontSize = 17,
  width = 70,
  height = 26,
  align = "center", // "center" | "left" | "right"
}) {
  const justify =
    align === "left" ? "flex-start" : align === "right" ? "flex-end" : "center";
  const boxX =
    align === "left" ? x : align === "right" ? x - width : x - width / 2;

  return (
    <foreignObject x={boxX} y={y - height / 2} width={width} height={height}>
      <div
        style={{
          color,
          fontSize,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: justify,
          width: "100%",
          height: "100%",
          whiteSpace: "nowrap",
        }}
      >
        <InlineMath math={String(math)} />
      </div>
    </foreignObject>
  );
}

// Marker kąta prostego: łuk w wierzchołku V (jak znacznik kąta) z kropką
// na dwusiecznej, we wnętrzu kąta.
// u, v to wektory (dowolnej długości) wzdłuż obu ramion kąta.
export function SvgRightAngle({ V, u, v, radius = 22, color = "currentColor", strokeWidth = 2 }) {
  const a0 = Math.atan2(u.y, u.x);
  let delta = Math.atan2(v.y, v.x) - a0;
  // najkrótsza droga kątowa (łuk po stronie wnętrza kąta)
  while (delta > Math.PI) delta -= 2 * Math.PI;
  while (delta < -Math.PI) delta += 2 * Math.PI;

  const N = 14;
  const pts = [];
  for (let i = 0; i <= N; i += 1) {
    const a = a0 + delta * (i / N);
    pts.push(`${(V.x + radius * Math.cos(a)).toFixed(1)},${(V.y + radius * Math.sin(a)).toFixed(1)}`);
  }

  const aMid = a0 + delta * 0.5;
  const dot = {
    x: V.x + radius * 0.5 * Math.cos(aMid),
    y: V.y + radius * 0.5 * Math.sin(aMid),
  };

  return (
    <g>
      <polyline points={pts.join(" ")} fill="none" stroke={color} strokeWidth={strokeWidth} />
      <circle cx={dot.x.toFixed(1)} cy={dot.y.toFixed(1)} r="2.6" fill={color} />
    </g>
  );
}
